import { Typography } from "antd";

const { Text } = Typography;

const TextEllipsis = ({ children }) => {
  return <Text ellipsis={{ tooltip: children }}>{children}</Text>;
};

export default TextEllipsis;
